module.exports = __webpack_public_path__ + "static/media/detail_0005_f.8ff2963c.jpg";